module.exports = __webpack_public_path__ + "img/cass5.2d119bae.jpg";